import styled from "styled-components";

export const Styles = styled.div`
  width: 100%;
  font-family: "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Meiryo", sans-serif !important;

  /* Optimize for Landscape printing */
  @media print {
    @page {
      size: landscape;
      margin: 10mm;
    }
  }

  .print-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    /* This allows the table itself to break across pages automatically */
    page-break-inside: auto;
    font-size: 11px; /* Smaller font to fit more columns */
    font-family: "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Meiryo",
      sans-serif !important;
  }

  .print-table th,
  .print-table td {
    border: 1px solid #d9d9d9;
    padding: 6px 8px;
    word-wrap: break-word;
    word-break: normal;
    white-space: pre-wrap;
  }

  .print-table th {
    background-color: #5182cc;
    color: white;
    font-weight: normal; /* DO NOT USE BOLD. Mac drops Kanji glyphs in print iframe if bold variant is missing! */
    text-align: left;
    /* Optional: vertical alignment */
    vertical-align: middle;
  }

  .print-table td {
    background-color: #ffffff;
    color: #333;
    vertical-align: top;
  }

  /* Magic for PDF multi-page headers */
  .print-table thead {
    display: table-header-group;
  }

  /* Magic for multi-page footers */
  .print-table tfoot {
    display: table-footer-group;
  }

  /* Keep rows together if possible, don't slice them in half */
  .print-table tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  /* Alternating row colors, if desired */
  /* .print-table tbody tr:nth-child(even) td {
    background-color: #fcfcfc;
  } */

  .print-table-summary {
    font-weight: bold;
    background-color: #f5f5f5;
  }
`;
